import enviro from 'enviro';
import idpAuthApiClient from 'hub-http-janus/clients/idpAuthApiClient';
import userInfo from 'hubspotter-http/hubSpotterInfo';
import { registerQuery, useQuery } from 'data-fetching-client';
import { createRpcClientV2 } from 'rpc-client-utils';
import { useGetSecureInstallComplianceQuery } from '../../__generated__/chirp/com/hubspot/marketplace/installs/rpc/MarketplaceInstallsSecureInstallComplianceRpc.hooks';
import { getSecureInstallComplianceRpc } from '../../__generated__/chirp/com/hubspot/marketplace/installs/rpc/MarketplaceInstallsSecureInstallComplianceRpc-internal';
const QA_PORTAL_ID = 99166168;
const PROD_PORTAL_ID = 521324;
const isQa = () => enviro.isQa();
async function getSecureInstallComplianceInternal({
  listingId
}) {
  const chirpClient = createRpcClientV2({
    hubHttpClient: idpAuthApiClient
  });
  const {
    hubspotter: user
  } = await userInfo();
  const userId = Number(user.employeeId) || 0;
  return chirpClient.call(getSecureInstallComplianceRpc, {
    request: {
      listingId
    },
    portalId: isQa() ? QA_PORTAL_ID : PROD_PORTAL_ID,
    userId
  });
}
const GET_SECURE_INSTALL_COMPLIANCE_INTERNAL = registerQuery({
  fieldName: 'secureInstallComplianceInternal',
  args: ['listingId'],
  fetcher: getSecureInstallComplianceInternal
});
export function useGetSecureInstallCompliance({
  listingId,
  skip = false,
  useInternalAuth = false
}) {
  const {
    data: appAuthData,
    loading: appAuthLoading,
    error: appAuthError
  } = useGetSecureInstallComplianceQuery({
    variables: {
      listingId: listingId
    },
    skip: skip || !listingId || useInternalAuth
  });
  const {
    data: internalData,
    loading: internalLoading,
    error: internalError
  } = useQuery(GET_SECURE_INSTALL_COMPLIANCE_INTERNAL, {
    variables: {
      listingId: listingId
    },
    skip: skip || !listingId || !useInternalAuth
  });
  const data = useInternalAuth ? internalData === null || internalData === void 0 ? void 0 : internalData.secureInstallComplianceInternal : appAuthData;
  const loading = useInternalAuth ? internalLoading : appAuthLoading;
  const error = useInternalAuth ? internalError : appAuthError;
  return {
    data,
    loading,
    error
  };
}